import { Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { BacklogKarte } from "./BacklogKarte.js";
import { LiegezeitBlock } from "./LiegezeitBlock.js";
import { MonatsDiagramm } from "./MonatsDiagramm.js";
import { ReaktionBlock } from "./TicketBloecke.js";

/**
 * Die vier Ticket-Blöcke des Lead-Detail (Spec 2.1c): Monate, eigener Backlog,
 * erste Reaktion, Liegezeit. Eine gewählte Beauftragung grenzt alle vier auf
 * ihre Kundenabteilung ein; Die Filterzeile steht im Lead-Detail über den Kennzahlen.
 */
export function LeadTicketBloecke({
  segmentId,
  year,
  leadId,
  beauftragung,
}: {
  segmentId: string;
  year: number;
  leadId: string;
  beauftragung: { id: string; name: string } | null;
}) {
  const { t } = useTranslation();
  const eingrenzung = beauftragung ? { leadId, beauftragungId: beauftragung.id } : { leadId };
  return (
    <Stack gap="md" mb="md">
      <Text fw={700}>{t("pages.kpi.tickets.ueberschrift")}</Text>
      <MonatsDiagramm segmentId={segmentId} year={year} eingrenzung={eingrenzung} />
      <BacklogKarte segmentId={segmentId} leadId={leadId} eingrenzung={eingrenzung} />
      <ReaktionBlock segmentId={segmentId} year={year} eingrenzung={eingrenzung} />
      <LiegezeitBlock segmentId={segmentId} eingrenzung={eingrenzung} />
    </Stack>
  );
}
